import { useContext, useState, useEffect } from "react";
import { T } from "react-translator-component";
import { CheckInContext } from "../context/checkin";
import { HotelContext } from "../context/hotel";
import { useWebPush } from "../context/webpush";
import { Row, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Screen from "../components/Screen";
import CheckinCompleted from "./CheckIn/CheckinCompleted";
import AddToHomeScreen from "../components/AddToHomeScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const UserSetings = () => {
  const { data: checkIn } = useContext(CheckInContext);
  const { data: hotel } = useContext(HotelContext);
  const [isMobile, setIsMobile] = useState(null);
  const { permission, askNotificationPermission, isPwaInstalled } = useWebPush();
  const { pathname } = useLocation();

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isMobileDevice = /iphone|ipad|ipod|android|mobile/.test(userAgent);
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobile = isMobileDevice || hasTouchScreen;
    setIsMobile(isMobile);
  }, []);

  return (
    <Screen section="Settings" title={T('general.notifications')} description={T('general.notifications_description')}>
      <Row className="justify-content-center" style={{ maxWidth: 600, margin: 'auto' }}>
        <div className="mt-4">
          {(pathname === '/checkin/identify' && false) && <div className="card shadow m-3 p-2" style={{ border: "1px solid #EEE", borderRadius: 10 }}>
            <CheckinCompleted checkIn={checkIn} hotel={hotel} />
          </div>}

          <div className="card p-4 shadow text-center m-3" style={{ borderTop: "1px solid #EEE" }}>
            <span className="d-block mb-3">
              <FontAwesomeIcon icon={faBell} style={{ fontSize: 50, color: permission === 'granted' ? '#28a745' : permission === 'denied' ? '#dc3545' : '#007bff' }} className="mb-2" />
            </span>
            {permission !== 'granted' && <h4 className="text-center m-2">{T('general.notifications')}</h4>}
            {permission === 'granted' && <p>{T('notifications.accepted')}</p>}
            {(permission === 'default' || permission === 'ommited') && <p>{T('notifications.accept')}</p>}
            {permission === 'denied' && <p>{T('notifications.blocked')}</p>}
            <div className="content text-center">
              {(permission === 'default' || permission === 'ommited') && <div className="mt-2 mb-2">
                <Button
                  style={{ minWidth: '80%' }}
                  size={'lg'}
                  variant={'primary'}
                  type={'button'}
                  className="text-uppercase"
                  onClick={() => askNotificationPermission()}
                >
                  {T('notifications.enable')}
                </Button>
              </div>}
            </div>
          </div>

          {isMobile && !isPwaInstalled && (
            <div className="card shadow text-center m-3 p-4" style={{ borderTop: "1px solid #EEE" }}>
              <AddToHomeScreen />
            </div>
          )}
        </div>
      </Row>
    </Screen>
  );
};

export default UserSetings;
